import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IChangeDataTimeline, IEpgPageState, IEpgSegment, ITimelineHour} from "../../interfaces/IEpgPageState.ts";
import api from "../../newApi/apiNet.ts";
import {IChannel} from "../../interfaces/IChannel.ts";
import apiNet from "../../newApi/apiNet.ts";
import {AxiosHeaders} from "axios";
import {IEpgItem} from "../../interfaces/IEpgItem.ts";
import {RootState} from "../../stores/store.ts";
import {IChannelEpgPage} from "../../interfaces/IChannelEpgPage.tsx";

const initialEpgPageState: IEpgPageState = {
    channelsBasic: [],
    channels: [],
    changeDateTimelines: [],
    isAvailableInBMGOFilterOn: false,
    isChangeTimelineDatePopupOpen: false,
    isFilterPopupOpen: false,
    selectedChangeDateTimeline: {name: '', timestamp: -1},
    timelineHours: [],
    // test
    isTimelineLoaded: false,
    epgEndTimestamp: 0,
    epgStartTimestamp: 0,
    epgActualRangeFromTimestamp: 0,
    epgActualRangeToTimestamp: 0,
    epgLastDownloadPointTimestamp: 0,
    epgDataAll: [],
    epgDataAllRanges: [],
    epgSegments: [],
    epgChangeDirection: "right",
    isEpgSegmentDownloading: false,
    searchInputValue: "",
    isInitialRunComplete: false
}

// function processEpgData(newEpgData: IEpgItem[], existingData: IEpgItem[]) {
//     const epgDataAllTemp = [...existingData]; // Tworzymy kopię istniejących danych
//     const chunkSize = 1000;
//     let index = 0;

//     function processChunk() {
//         const chunk = newEpgData.slice(index, index + chunkSize);
//         chunk.forEach(newEpg => {
//             if (!epgDataAllTemp.some(epg => epg.id === newEpg.id)) {
//                 epgDataAllTemp.push(newEpg);
//             }
//         });

//         index += chunkSize;
//         if (index < newEpgData.length) {
//             setTimeout(processChunk, 0); // Przetwarzaj następny chunk
//         } else {
//             return epgDataAllTemp;
//         }
//     }

//     return new Promise((resolve) => {
//         processChunk();
//         resolve(epgDataAllTemp);
//     });
// }

export const epgPageSlice = createSlice({
    name: "epgPage",
    initialState: initialEpgPageState,
    reducers: {
        setInitialState: () => initialEpgPageState,
        setChannelsBasic: (state: IEpgPageState, action: PayloadAction<IChannel[]>) => {
            if (state.channelsBasic.length === 0) {
                let channelsTemp: IChannel[] = [...action.payload];
                channelsTemp = channelsTemp.map((x) => {
                    return {...x, epgList: []}
                });
                state.channelsBasic = channelsTemp;
            }
        },
        setChangeDateTimelines: (state: IEpgPageState, action: PayloadAction<IChangeDataTimeline[]>) => {
            state.changeDateTimelines = action.payload;
        },
        setIsChangeTimelineDatePopupOpen: (state: IEpgPageState, action: PayloadAction<boolean>) => {
            state.isChangeTimelineDatePopupOpen = action.payload
        },
        setIsFilterOpen: (state: IEpgPageState, action: PayloadAction<boolean>) => {
            state.isFilterPopupOpen = action.payload;
        },
        setSelectedChangeDataTimeline: (state: IEpgPageState, action: PayloadAction<IChangeDataTimeline>) => {
            state.selectedChangeDateTimeline = action.payload;
        },
        toggleIsAvailableInBMGOFilterOn: (state: IEpgPageState) => {
            state.isAvailableInBMGOFilterOn = !state.isAvailableInBMGOFilterOn;
        },
        toggleIsFilterOpen: (state: IEpgPageState) => {
            if (!state.isFilterPopupOpen) {
                if (state.isChangeTimelineDatePopupOpen)
                    state.isChangeTimelineDatePopupOpen = false;
            }
            state.isFilterPopupOpen = !state.isFilterPopupOpen;
        },
        toggleIsChangeTimelineDatePopupOpen: (state: IEpgPageState) => {
            if (!state.isChangeTimelineDatePopupOpen) {
                if (state.isFilterPopupOpen)
                    state.isFilterPopupOpen = false;
            }
            state.isChangeTimelineDatePopupOpen = !state.isChangeTimelineDatePopupOpen;
        }
        // test
        ,
        setEpgStartTimestamp: (state: IEpgPageState, action: PayloadAction<number>) => {
            state.epgStartTimestamp = action.payload;
        },
        setEpgEndTimestamp: (state: IEpgPageState, action: PayloadAction<number>) => {
            state.epgEndTimestamp = action.payload;
        },
        setEpgLastDownloadPointTimestamp: (state: IEpgPageState, action: PayloadAction<number>) => {
            state.epgLastDownloadPointTimestamp = action.payload;
        },
        setIsTimelineLoaded: (state: IEpgPageState) => {
            state.isTimelineLoaded = true;
        },
        setIsEpgSegmentDownloading: (state: IEpgPageState, action: PayloadAction<boolean>) => {
            state.isEpgSegmentDownloading = action.payload;
        },
        setTimelineHours: (state: IEpgPageState, action: PayloadAction<ITimelineHour[]>) => {
            state.timelineHours = action.payload;
        },
        setEpgActualRangeFromTimestamp: (state: IEpgPageState, action: PayloadAction<number>) => {
            state.epgActualRangeFromTimestamp = action.payload;
        },
        setEpgActualRangeToTimestamp: (state: IEpgPageState, action: PayloadAction<number>) => {
            state.epgActualRangeToTimestamp = action.payload;
        },
        setChangeDirection: (state: IEpgPageState, action: PayloadAction<"left" | "right">) => {
            state.epgChangeDirection = action.payload
        },
        setEpgSegments: (state: IEpgPageState, action: PayloadAction<IEpgSegment[]>) => {
            state.epgSegments = action.payload;
        },
        setSearchInputValue: (state: IEpgPageState, action: PayloadAction<string>) => {
            state.searchInputValue = action.payload;
        },
        updateChannel(state, action: PayloadAction<IChannelEpgPage>) {
            const index = state.channels.findIndex(c => c.ch_id === action.payload.ch_id);
            if (index !== -1) {
                state.channels[index] = action.payload;
            }
        },
        updateEpgDataAll: (state: IEpgPageState, action: PayloadAction<{
            id: number,
            name: string,
            start_timestamp: number,
            stop_timestamp: number
        }[]>) => {
            action.payload.map(epg => {
                const epgIndex = state.epgDataAll.findIndex(x => x.id === epg.id);
                if (!epgIndex)
                    state.epgDataAll.push(epg);
            });
        }
    },
    extraReducers(builder) {
        builder.addCase(getInitialEpgPage.fulfilled, (state, action) => {
            const sortedChannels = action.payload.data.sort(x => x.position);
            state.channels = sortedChannels;
            state.epgActualRangeFromTimestamp = action.payload.fromDateTime;
            state.epgActualRangeToTimestamp = action.payload.toDateTime;
            state.isInitialRunComplete = true;
        });
        // builder.addCase(getEpgsSegment1.fulfilled, (state, action) => {

        //     // setTimeout(() => {

        //     if (!state.isEpgSegmentDownloading) {
        //         state.isEpgSegmentDownloading = true;
        //         const segment = state.epgSegments.find(x => x.fromTimestamp === action.payload.fromTimestamp);
        //         const epgAllTemp = state.epgDataAll;
        //         action.payload.data.map(newEpg => {
        //             const epgExist = epgAllTemp.includes(newEpg);
        //             if (!epgExist) {
        //                 epgAllTemp.push(newEpg);
        //             }
        //         });
        //         state.epgDataAll = epgAllTemp;
        //         if (segment)
        //             segment.isSegmentDownloaded = true;
        //     }
        //     state.isEpgSegmentDownloading = false;
        //     // }, 10);
        //     // from =
        // });
        builder.addCase(getEpgsSegment1.fulfilled, (state, action) => {
            if (!state.isEpgSegmentDownloading) {
                state.isEpgSegmentDownloading = true;
                action.payload.data.map(newEpg => {
                    state.epgDataAll.push(newEpg);
                });
                const segment = state.epgSegments.find(x => x.fromTimestamp === action.payload.fromTimestamp);
                if (segment)
                    segment.isSegmentDownloaded = true;
                state.isEpgSegmentDownloading = false;
            }
        });
        builder.addCase(getEpgsSegment.fulfilled, (state, action) => {


            action.payload.data.map(newEpg => {
                const epgIndex = state.epgDataAll.findIndex(x => x.id == newEpg.id);
                if (!epgIndex)
                    state.epgDataAll.push(newEpg);
            });
            const epgDataRange = state.epgDataAllRanges.find(x => x.to === action.payload.fromTimestamp || x.from === action.payload.toTimestamp || x.from === action.payload.fromTimestamp && x.to === action.payload.toTimestamp);
            // if (epgDataRange && epgDataRange.from === action.payload.fromTimestamp && epgDataRange.to === action.payload.toTimestamp) {
            // }
            if (epgDataRange && epgDataRange.to === action.payload.fromTimestamp)
                epgDataRange.to = action.payload.toTimestamp;
            else if (epgDataRange && epgDataRange.from === action.payload.toTimestamp)
                epgDataRange.from = action.payload.fromTimestamp;
            else if (!epgDataRange) {
                const lastDataRangeElem = state.epgDataAllRanges[state.epgDataAllRanges.length - 1];
                const idForNewRangeElem = lastDataRangeElem ? lastDataRangeElem.id + 1 : 0;
                state.epgDataAllRanges.push({
                    id: idForNewRangeElem,
                    from: action.payload.fromTimestamp,
                    to: action.payload.toTimestamp
                });
            }
            let isContinue = false;
            do {
                isContinue = false;
                state.epgDataAllRanges.forEach(item => {
                    const result = state.epgDataAllRanges.filter(x => x.from === item.to || x.to === item.from);
                    result.forEach(x => {

                        // if(x.to - x.from > item.to - item.from)
                        //     item.from =

                        if (x.from !== item.from || x.to !== item.to) {
                            item.from = item.from < x.from ? item.from : x.from;
                            item.to = item.to > x.to ? item.to : x.to;
                            // if (item.from === x.to)
                            //     item.from = x.to;
                            // else if(item.to === x.from)
                            //     item.to = x.from;
                            state.epgDataAllRanges = state.epgDataAllRanges.filter(y => y.id !== x.id);
                            isContinue = true;
                        }
                    })
                })
            } while (isContinue)
            // const to = state.epgDataAllRanges.filter(x => x);
        });
        builder.addCase(getEpgsForActualRange.fulfilled, (state, action) => {
            state.channels = action.payload.data;
        });
    }
})

export const getChannelsBasic = createAsyncThunk<string, { chId: number, url: string }>(
    "epg-page/get-channel-basic",
    async ({chId, url}, {rejectWithValue}) => {
        try {
            const token = await api.getToken(chId);
            return `${url}?token=${token.data}`;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const getInitialEpgPage = createAsyncThunk<{
    fromDateTime: number,
    toDateTime: number,
    data: IChannelEpgPage[]
}, {
    fromUnixTimestamp: number,
    hoursWidth: number
}>(
    "epgPage/get-initial-epg-page", async ({fromUnixTimestamp, hoursWidth}, {dispatch}) => {
        const result = await apiNet.getInitialEpgPage(fromUnixTimestamp, hoursWidth);
        const headers = result.headers;

        if (headers instanceof AxiosHeaders && headers.has('x-start-timestamp') && headers.has('x-end-timestamp') && headers.has('x-last-download-point-timestamp')) {
            dispatch(epgPageActions.setEpgStartTimestamp(Number(headers.get('x-start-timestamp'))));
            dispatch(epgPageActions.setEpgEndTimestamp(Number(headers.get('x-end-timestamp'))));
            dispatch(epgPageActions.setEpgLastDownloadPointTimestamp(Number(headers.get('x-last-download-point-timestamp'))));
        }
        return result.data;
    })

export const getEpgsSegment = createAsyncThunk<{
    fromTimestamp: number,
    toTimestamp: number,
    data: { id: number, name: string, start_timestamp: number, stop_timestamp: number }[]
}, { fromTimespan: number }>(
    "epg-page/get-segment",
    async ({fromTimespan}, {rejectWithValue}) => {
        try {
            const result = await api.getEpgsSegment(fromTimespan);
            return result.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const getEpgsSegment1 = createAsyncThunk<{
    fromTimestamp: number,
    toTimestamp: number,
    data: { id: number, name: string, start_timestamp: number, stop_timestamp: number }[]
}, { fromTimespan: number }, { state: RootState }>(
    "epg-page/get-segment1",
    async ({fromTimespan}, {rejectWithValue, getState}) => {
        try {
            const result = await api.getEpgsSegment(fromTimespan);
            const state = getState();
            let resultWebWorker: IEpgItem[] = [];

            return new Promise((resolve) => {
                const worker = new Worker(new URL('./../test/epgPageWebworker.ts', import.meta.url));

                worker.onmessage = function (event) {
                    resultWebWorker = event.data;
                    resolve({
                        data: resultWebWorker,
                        fromTimestamp: result.data.fromTimestamp,
                        toTimestamp: result.data.toTimestamp
                    })
                    worker.terminate();
                };
                const epgDataAllTemp = state.epgPage.epgDataAll;
                const newEpgData = result.data.data;
                worker.postMessage({epgDataAll: epgDataAllTemp, newEpgData});
            });
        } catch (error) {
            return rejectWithValue(error);
        }
    }
)

export const getEpgsForActualRange = createAsyncThunk<{
    data: IChannelEpgPage[]
}, { fromTimestamp: number, toTimestamp: number }, { state: RootState }>(
    "epg-page/get-epgs-for-actual-range",
    ({fromTimestamp, toTimestamp}, {getState}) => {
        const state = getState();
        return new Promise((resolve) => {
            const worker = new Worker(new URL('./../../webWorkers/epgPage/getEpgsForActualRangeWebWorker.ts', import.meta.url));

            worker.onmessage = function (event) {
                const channelsWithEpgsForActualRange = event.data;
                resolve({data: channelsWithEpgsForActualRange})
                worker.terminate(); // Terminate the worker after processing
            };
            const epgDataAllTemp = state.epgPage.epgDataAll;
            const channels = state.epgPage.channels;
            worker.postMessage({channels, epgDataAll: epgDataAllTemp, fromTimestamp, toTimestamp});
        });
    }
)


export const epgPageActions = epgPageSlice.actions;